import BookIndex from "components/shared/book/list";
import InlineBtn from "components/shared/inlineBtn";
import SharedReactTable from "components/shared/reactTable";
import { dateTimeToView } from "helpers/date";
import { paths } from "helpers/paths";
import { DateColumnFilter, rowIndexColumn } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import policy from "policies";
import React from "react";

class CalclationQueueList extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "ID заявки",
                accessor: "bidId",
                filterType: "int",
                filterable: true,
                Cell: ({ value }) => (
                    <a target="_blank" rel="noopener noreferrer" href={paths.bidShow("bid", value)}>
                        {value}
                    </a>
                ),
            },
            {
                Header: "Вычислено (calculatedAt)",
                accessor: "calculatedAt",
                filterable: true,
                filterType: "date",
                Filter: DateColumnFilter,
                Cell: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
                CSVExport: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
            },
            {
                Header: "Выполнено (finishedAt)",
                accessor: "finishedAt",
                filterable: true,
                filterType: "date",
                Filter: DateColumnFilter,
                Cell: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
                CSVExport: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
            },
            { Header: "flags", accessor: "flags" },
            { Header: "Статус", accessor: "status" },
        ];
    }

    renderActions = () => {
        const { mergeParams, roles } = this.props;
        const createRecalculate = () => {
            const { modal } = this.props;
            return modal({
                name: "createRecalculate",
                title: "Перерасчет по заявке",
                mod: "create-route",
                mergeParams,
            });
        };
        const actions = policy("user", { user: { roles } }).isAdminWithWriteAccess()
            ? [
                  { value: "Обновить", cname: "refresh", active: true, action: mergeParams, params: {} },
                  { value: "Добавить заявку для перерасчета", cname: "plus", active: true, action: createRecalculate },
                  {
                      value: "Перерасчет пробегов",
                      cname: "plus",
                      active: true,
                      action: () => this.props.history.push(paths.calculationQueuesNew),
                  },
              ]
            : [{ value: "Обновить", cname: "refresh", active: true, action: mergeParams, params: {} }];
        return actions.map((item, index) => <InlineBtn key={index} {...item} />);
    };

    renderListComponent = () => {
        return <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
    };
}

export default tableContainer(CalclationQueueList, "calculationqueues");
